import type { MechKey } from './keys';

export const fa: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'مکانیک · 2D',
  'panel.scene': 'صحنه',
  'panel.dims': 'پارامترها',
  'panel.style': 'ظاهر',
  'panel.action': 'کنترل',
  'style.body': 'جسم',
  'style.vector': 'بردارها',
  'style.ground': 'زمین',
  'style.forces': 'نمایش نیروها',
  'style.trace': 'نمایش مسیر',
  'style.labels': 'برچسب بردارها',
  'hint.line1': 'برای شروع پخش را کلیک کنید · اجسام را بکشید تا جابجا شوند',
  'hint.line2': 'سندباکس: شکلی انتخاب کنید، سپس برای قرار دادن کلیک کنید',
  'scene.incline': 'سطح شیب‌دار',
  'scene.projectile': 'حرکت پرتابه',
  'scene.pendulum': 'آونگ',
  'scene.springMass': 'سیستم فنر-جرم',
  'scene.collisions': 'برخوردها',
  'scene.atwood': 'دستگاه اتوود',
  'scene.circular': 'حرکت دایره‌ای',
  'scene.sandbox': 'سندباکس',
  'dim.angle': 'زاویه (°)',
  'dim.friction': 'اصطکاک',
  'dim.mass': 'جرم',
  'dim.massA': 'جرم A',
  'dim.massB': 'جرم B',
  'dim.velocity': 'سرعت',
  'dim.angleLaunch': 'زاویه پرتاب (°)',
  'dim.gravity': 'گرانش',
  'dim.gravityX': 'گرانش x',
  'dim.gravityY': 'گرانش y',
  'dim.length': 'طول',
  'dim.damping': 'میرایی',
  'dim.spring': 'سختی',
  'dim.restitution': 'ضریب بازگشت',
  'dim.radius': 'شعاع',
  'dim.speed': 'تندی',
  'action.play': 'پخش',
  'action.pause': 'مکث',
  'action.step': 'گام',
  'action.reset': 'بازنشانی',
  'action.speed': 'سرعت',
  'action.clear': 'پاک کردن',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'نیروی گرانش',
  'forceName.normal': 'نیروی عمودی',
  'forceName.friction': 'نیروی اصطکاک',
  'forceName.tension': 'کشش',
  'forceName.spring': 'نیروی فنر',
  'forceName.applied': 'نیروی اعمال شده',
  'forceName.air': 'مقاومت هوا',
  'palette.box': 'جعبه',
  'palette.circle': 'توپ',
  'palette.ramp': 'شیب',
  'palette.ground': 'زمین',
  'palette.hint': 'شکلی انتخاب کنید، سپس روی بوم کلیک کنید تا قرار گیرد.',
  'panel.forces': 'نیروهای مشاهده شده',
  'forces.empty': 'هنوز هیچی نیست — صحنه را پخش کنید',
};
